import React, { useRef, useState } from 'react';
import Button from '../Button/Button';
import styles from './FileInput.module.scss';

const FileInput = ({ label, allowedFormats, onFileSelect }) => {
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedMimeTypes = ['image/jpeg', 'image/png'];
      if (!allowedMimeTypes.includes(file.type)) {
        setError('Неправильний формат файлу. Дозволено: .png, .jpg, .jpeg');
        setFileName('');
        onFileSelect(null);
        return;
      }

      setFileName(file.name);
      setUploading(true);
      setError(null);

      const formData = new FormData();
      formData.append('logo', file);

      try {
        const response = await fetch('/api/quiz/upload-logo', {
          method: 'POST',
          headers: {
            'X-API-Key': process.env.REACT_APP_API_KEY,
          },
          body: formData,
        });

        if (response.ok) {
          const data = await response.json();
          onFileSelect(data.filePath);
        } else {
          if (response.status === 413) {
            setError('Файл занадто великий. Максимальний розмір: 10 МБ.');
          } else {
            const errorText = await response.text();
            setError(`Помилка завантаження: ${errorText}`);
          }
          onFileSelect(null);
        }
      } catch (err) {
        setError(`Помилка завантаження: ${err.message}`);
        onFileSelect(null);
      } finally {
        setUploading(false);
      }
    }
  };

  return (
    <div className={styles.container}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.inputRow}>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className={styles.hiddenInput}
          accept=".png, .jpg, .jpeg"
        />
        <Button variant="outline" onClick={handleButtonClick}>
          Вибрати файл
        </Button>
        <span className={styles.fileName}>{fileName || allowedFormats}</span>
      </div>
      {uploading && <span className={styles.uploading}>Завантаження...</span>}
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default FileInput;